import { isApiError, NETWORK_ERROR, TOO_MANY_REQUESTS } from './errors';

/**
 * 오류 코드 → 화면 문구 (해요체).
 *
 * 서버 description 은 운영 로그용 합니다체라 화면에 그대로 쓰지 않는다.
 * 문구는 "Navigating error" 원칙 — 무엇이 문제인지와 다음에 할 일을 함께 말한다.
 */
const MESSAGES: Record<string, string> = {
  AUTH_INVALID_CREDENTIALS:
    '이메일 또는 비밀번호가 맞지 않아요. 팬즈드롭 앱에 로그인할 때 쓰는 정보로 다시 입력해 주세요.',
  AUTH_ACCOUNT_NOT_FOUND: '가입된 계정이 없어요. 팬즈드롭 앱에서 가입한 계정으로 로그인해 주세요.',
  AUTH_ACCOUNT_DEACTIVATED: '이용이 중지된 계정이에요. 고객센터로 문의해 주세요.',
  AUTH_NOT_CREATOR:
    '크리에이터 계정만 파트너 페이지를 쓸 수 있어요. 크리에이터 계정으로 로그인해 주세요.',
  AUTH_SOCIAL_AUTH_FAILED: '소셜 계정을 확인하지 못했어요. 다시 시도해 주세요.',
  AUTH_TOKEN_EXPIRED: '로그인이 만료됐어요. 다시 로그인해 주세요.',
  AUTH_TOKEN_INVALID: '로그인이 만료됐어요. 다시 로그인해 주세요.',
  AUTH_TOKEN_BLACKLISTED: '로그인이 만료됐어요. 다시 로그인해 주세요.',
  AUTH_REFRESH_TOKEN_INVALID: '로그인이 만료됐어요. 다시 로그인해 주세요.',
  AUTH_UNAUTHORIZED: '로그인이 필요해요.',
  AUTH_FORBIDDEN: '이 화면을 볼 수 있는 권한이 없어요.',

  STATS_INVALID_RANGE: '시작일이 종료일보다 늦어요. 기간을 다시 골라 주세요.',
  STATS_RANGE_TOO_LONG:
    '조회 기간이 너무 길어요. 일 단위는 92일, 주 단위는 53주, 월 단위는 24개월까지 볼 수 있어요.',
  STATS_INVALID_CURSOR: '목록 위치를 잃었어요. 처음부터 다시 불러와 주세요.',

  PAYOUT_PROFILE_REQUIRED: '정산 정보를 먼저 등록해 주세요.',
  PAYOUT_PROFILE_NOT_VERIFIED: '정산 정보 확인이 끝나면 출금을 신청할 수 있어요.',
  PAYOUT_PROFILE_LOCKED: '처리 중인 출금이 있어서 지금은 정산 정보를 바꿀 수 없어요.',
  PAYOUT_RESIDENT_NUMBER_INVALID: '주민등록번호(외국인등록번호)를 다시 확인해 주세요.',
  PAYOUT_BUSINESS_NUMBER_INVALID: '사업자등록번호를 다시 확인해 주세요.',
  PAYOUT_IDENTITY_REQUIRED: '주민등록번호나 사업자 정보 중 필요한 정보를 입력해 주세요.',
  PAYOUT_PROFILE_NOT_FOUND: '등록된 정산 정보가 없어요.',

  SETTLEMENT_MINIMUM_NOT_MET: '최소 출금 금액보다 적어요. 금액을 다시 확인해 주세요.',
  SETTLEMENT_INSUFFICIENT_BALANCE: '출금 가능 금액보다 많아요. 금액을 다시 확인해 주세요.',
  SETTLEMENT_RULE_NOT_FOUND: '세금 계산 기준을 불러오지 못했어요. 잠시 후 다시 시도해 주세요.',

  QR_LOGIN_SESSION_EXPIRED: 'QR 코드 유효 시간이 지났어요. 새 QR 코드를 받아 주세요.',
  QR_LOGIN_POLL_TOKEN_INVALID: 'QR 로그인 정보가 맞지 않아요. 새 QR 코드를 받아 주세요.',
  QR_LOGIN_INVALID_STATE: '이미 처리된 QR 코드예요. 새 QR 코드를 받아 주세요.',

  [TOO_MANY_REQUESTS]: '요청이 많아 잠시 쉬어 가요. 조금 뒤에 다시 시도해 주세요.',
  [NETWORK_ERROR]: '인터넷 연결이 불안정해요. 연결을 확인하고 다시 시도해 주세요.',
};

export const DEFAULT_ERROR_MESSAGE = '일시적인 문제가 생겼어요. 잠시 후 다시 시도해 주세요.';
const VALIDATION_ERROR_MESSAGE = '입력한 내용을 다시 확인해 주세요.';

/** 오류를 화면 문구로 바꾼다 */
export function getErrorMessage(error: unknown): string {
  if (!isApiError(error)) return DEFAULT_ERROR_MESSAGE;
  const message = MESSAGES[error.code];
  if (message) return message;
  // class-validator 400 (code 'Bad Request') — 클라이언트 검증을 통과한 뒤라 드문 경우
  if (error.status === 400) return VALIDATION_ERROR_MESSAGE;
  return DEFAULT_ERROR_MESSAGE;
}
